<template>
  <div class="flex flex-col gap-9 items-start w-full">
    <div class="flex flex-col w-full gap-2">
      <div class="flex items-center gap-2">
        <button @click="$router.back()"><font-awesome-icon icon="fa-solid fa-arrow-left" /></button>
        <p class="text-sm text-white font-semibold">Profile</p>
      </div>
      <div class="flex flex-col gap-3 items-center justify-center">
        <div class="relative">
          <div
            class="w-20 h-20 flex items-center pt-4 overflow-hidden justify-center rounded-full bg-BLACK"
          >
            <img v-if="userStore.photoUrl" :src="userStore.photoUrl" class="h-16" />
            <img v-else src="@/assets/images/pow_logo.svg" />
          </div>
          <div
            class="w-7 h-7 rounded-full border bg-PRIMARY border-white flex items-center justify-center text-sm text-white font-semibold absolute -bottom-2 left-1/2 -translate-x-1/2"
          >
            {{ gameStore.level }}
          </div>
        </div>
        <div class="flex flex-col gap-1.5 items-center justify-center">
          <span  class="text-sm" >{{ gameStore.getLevelName() }}</span>
          <p class="text-sm font-semibold text-white">
            {{ userStore.getName() }}
          </p>
          <div class="flex items-center gap-1.5">
            <img src="../assets/icons/token-2.svg" class="w-5 object-contain" />
            <p class="text-sm font-semibold text-white">{{ gameStore.totalTokenPrintable }}</p>
          </div>
        </div>
      </div>
    </div>
    <ProfileTabViewHeader v-model:model-value="activeTab"></ProfileTabViewHeader>
    <Transition name="slide-left" mode="out-in">
      <component :is="currentComponent" />
    </Transition>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

import ProfileTabViewHeader from '@/components/ProfileTabViewHeader.vue'
import CharacterTab from '@/components/profileViewTabs/CharacterTab.vue'
import ReferalsTab from '@/components/profileViewTabs/ReferalsTab.vue'
import ActivityTab from '@/components/profileViewTabs/ActivityTab.vue'
import SettingsTab from '@/components/profileViewTabs/SettingsTab.vue'
import { useUserStore } from '@/stores/user'
import { useGameStore } from '@/stores/game'

const userStore = useUserStore()
const gameStore = useGameStore()

const tabList = ref([CharacterTab, ReferalsTab, ActivityTab, SettingsTab])
const activeTab = ref()

const currentComponent = computed(() => {
  return tabList.value[activeTab.value]
})
</script>
